import { determineVMType } from '../../../../utils/validation/network-validation';
import { BlockchainType } from '../../../../types/services/enums';
//single input single network
export async function getSingleNetworkPrice({ network, tokensIn, tokensOut, amountsIn, slippages, fromAddress, baseUrl, permitBatchDetail, permitSignature, priorityFee, PKP, }) {
    const url = baseUrl + '/price/single-chain';
    const blockchainType = determineVMType(network);
    let traderAddress = PKP === null || PKP === void 0 ? void 0 : PKP.additionalEthAddress;
    if (blockchainType === BlockchainType.SVM) {
        traderAddress = PKP === null || PKP === void 0 ? void 0 : PKP.solanaAddress;
    }
    else if (blockchainType === BlockchainType.MOVE) {
        traderAddress = PKP === null || PKP === void 0 ? void 0 : PKP.suiAddress;
    }
    const permit = {
        permitBatch: permitBatchDetail,
        signature: permitSignature,
    };
    const requestBody = {
        network,
        tokenIn: tokensIn[0],
        tokenOut: tokensOut[0],
        amountIn: amountsIn[0],
        slippage: slippages[0],
        from: fromAddress,
        permit: permit,
        priorityFee: priorityFee,
        PKP,
    };
    console.log(`SINGLE_CHAIN_PRICE_REQUEST`, requestBody);
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        });
        const data = await response.json();
        console.log('single network price', data);
        if (data.error) {
            throw new Error(data.error);
        }
        return data;
    }
    catch (error) {
        console.log('normal Url-------------------', url);
        console.error('Error fetching single network price', error);
        return { error: error.message };
    }
}
